import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

/*
 * Globale Aktionsleiste: Seiten melden ihren Kontext (ausgewählter Datensatz,
 * geladene Liste, "+"-Aktion) über useActionBarConfig an die Leiste.
 * selected: { kind: 'guardian'|'student', id, name, email, phone } | null
 * list: { kind: 'guardian'|'student', ids: [] } | null
 * onNew: fn | null, newLabel: string
 * newMenu: [{ id, label, description?, onClick }] | null
 *   Wenn gesetzt, öffnet „+“ ein Auswahlmenü statt onNew direkt.
 * requestAction('print'|'mail-single'|'mail-bulk'|'mail-free'|'sms'|'app'|'invoice')
 *   öffnet den entsprechenden Dialog in der ActionBar.
 */
const ActionBarContext = createContext({
  config: {},
  setConfig: () => {},
  pendingAction: null,
  requestAction: () => {},
  clearPendingAction: () => {},
});

export function ActionBarProvider({ children }) {
  const [config, setConfig] = useState({});
  const [pendingAction, setPendingAction] = useState(null);
  const requestAction = useCallback((action) => setPendingAction(action), []);
  const clearPendingAction = useCallback(() => setPendingAction(null), []);
  return (
    <ActionBarContext.Provider value={{
      config, setConfig, pendingAction, requestAction, clearPendingAction,
    }}>
      {children}
    </ActionBarContext.Provider>
  );
}

export const useActionBar = () => useContext(ActionBarContext);

export function useActionBarConfig(cfg, deps) {
  const { setConfig } = useActionBar();
  useEffect(() => {
    setConfig(cfg);
    return () => setConfig({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
